export const debugEndpoints = {
  jobSourcing: '/debug/job-sourcing/{jobId}',
} as const;
